export const ResultCardConstants = {
   resultContainer: 'result-container',
   resultHeading: 'result-heading',
   getStarted: 'get-started',
   allSpeeds: 'all-speeds',
};
